import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Line from "../../atoms/HorizontalLine";
import Button from "../../atoms/Button";

const BidCancelBox = ({ open, onOk, onCancel }) => {
  return (
    <div>
      <DiaglogBox
        open={open}
        onOk={onOk}
        onCancel={onCancel}
        width={400}
        className
      >
        <div className="drop-shadow-custom">
          <h1 className="text-center text-grey-800 mb-3 font-medium text-[15px]">
            Bid Cancel
          </h1>

          <Line />
          <div className="mx-4 my-6 text-center text-grey-800 font-medium text-[15px]">
            <h1>Are you sure you want to cancel this bid?</h1>
          </div>

          <div className="flex justify-center items-center gap-1.5 mx-4 mb-5">
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[9.375rem] px-9 py-1 text-sm justify-right lg:py-2 text-white font-bold  bg-blue-800   "
              onClick={onOk}
            >
              Yes
            </Button>
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[9.375rem]  px-9 py-1 text-sm justify-right lg:py-2  border-[1px] border-blue-800 font-bold text-blue-800 bg-blue-100   "
              onClick={onCancel}
            >
              No
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default BidCancelBox;
